import React, { Component } from 'react'
import { Column33 } from './Column'
import NumberFormat from 'react-number-format'
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip'
import { H4 } from './Text'


class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { isSticky: false 
    };
  }

  componentWillMount = () => {
    const { theoreticalGrowthFactor, futurePMFactor, futurePEFactor } = this.props.valuation;

    this.setState({
      growth: theoreticalGrowthFactor,
      PM: futurePMFactor,
      PE: futurePEFactor
    })
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    var rect = ReactDOM.findDOMNode(this).getBoundingClientRect()
    if (rect.top < 10) {
      this.setState({ isSticky: false }) //04/28/20 changed this to false to accommodate the PM and PE Sliders
    } else {
      this.setState({ isSticky: false })
    }
  }

  handleGrowthChange = (event) => {
    const growth = Number(this.growthSlider.value);
    const PM = Number(this.PMSlider.value);
    const PE = Number(this.PESlider.value);
    this.setState({ value: event.target.value });
    this.props.updateValuation(growth, PM, PE);
    this.setState({
      growth, PM, PE
    })
  }

  handlePMChange = (event) => {
    const PM = Number(this.PMSlider.value);
    const growth = Number(this.growthSlider.value);
    const PE = Number(this.PESlider.value);
    this.setState({ value: event.target.value });
    this.props.updateValuation(growth, PM, PE)
    this.setState({
      growth, PM, PE
    })
  }

  handlePEChange = (event) => {
    const PE = Number(this.PESlider.value);
    const growth = Number(this.growthSlider.value);
    const PM = Number(this.PMSlider.value);
    this.setState({ value: event.target.value });
    this.props.updateValuation(growth, PM, PE)
    this.setState({
      growth, PM, PE
    })
  }
  handleGrowthClick = (ref) => {
    const growth = ref.props.value / 100
    const PM = Number(this.PMSlider.value);
    const PE = Number(this.PESlider.value);
    this.setState({ value: ref.props.value });
    this.props.updateValuation(growth, PM, PE)
    this.setState({
      growth, PM, PE
    })
  }

  handlePMClick = (ref) => {
    const PM = ref.props.value / 100
    const growth = Number(this.growthSlider.value);
    const PE = Number(this.PESlider.value);
    this.setState({ value: ref.props.value });
    this.props.updateValuation(growth, PM, PE)
    this.setState({
      growth, PM, PE
    })
  }

  handlePEClick = (ref) => {
    const PE = ref.props.value
    const growth = Number(this.growthSlider.value);
    const PM = Number(this.PMSlider.value);
    this.setState({ value: ref.props.value });
    this.props.updateValuation(growth, PM, PE)
    this.setState({
      growth, PM, PE
    })
  }

  render() {
    const { valuation } = this.props
    const { theoreticalGDefault, futurePMDefault, futurePEDefault } = valuation
    const isSticky = this.state.isSticky
    const className = {
      sticky: 'fixed-ns top-2-ns bt bw1 b--blue',
      normal: ''
    }

    return (
      <Column33>

        <div className={` bg-white br2 shadow-custom relative top--2 ${isSticky ? className.sticky + className.normal : className.normal}`}>
          <div className="group pa3 ">
            <span><H4>
              Sales Growth (gs) Slider
                  <i data-tip data-for='growthSlider' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='growthSlider' place='top' class='mw6'>
                    <p className="f6">(1+gs) = (1+ge)(1+Shrg)/(1+PMg) where gs is growth in Total Sales, ge is growth in EPS, Shrg is growth in shares, and PMg is growth in Profit Margin. </p>
                  </ReactTooltip>
            </H4> </span>
            <span> 
            <a className="link blue" href={"https://youtu.be/dBuM9wcdVAw?list=PL2dQtklQds_vMRcyDmyLhMV7q5zEVEex4&t=1395"} target="_blank"> How To </a>
        </span>
            <p className="f6 gray">Projected sales growth is a significant factor in valuation. Move the slider to a value of your choosing. Click on Default, Company, Industry, or SP500 to set to a predetermined value. Projected sales growth is an average annual sales growth over the next 5 years. </p>
            <p className="f6 gray">Click on <strong>Default</strong> to reset.</p>
            <ul className="list ma0 pa0">
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handleGrowthClick(this.theoreticalGrowthRef) }}>Default
                  <i data-tip data-for='default' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='default' place='top' class='mw6'> 
                    <p className="f6">The <strong>Default</strong> sales growth value is determined from consensus analysts’ forecasted earnings growth or extrapolated from recent sales. 
                    Consensus analysts' sales growth (Sales=Dampened Earnings/Profit Margin) is used for a Stable company whose operations are assumed to persist. Extrapolated sales growth is used for 
                    a Dynamic company whose recent sales trend is assumed to be accelerating. Both are adjusted using proprietary methods that consider the market implied sales 
                    growth derived from the current price and the Future PM and Future PE slider values. </p>
                  </ReactTooltip>
                </span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(theoreticalGrowthRef) => { this.theoreticalGrowthRef = theoreticalGrowthRef }}
                    value={theoreticalGDefault * 100}
                    decimalPrecision={0}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handleGrowthClick(this.companyGrowthRef) }}>Company
                <i data-tip data-for='companyGrowth' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='companyGrowth' place='top' class='mw6'>
                    <p className="f6">The company's historical sales trend over last 3 years</p>
                  </ReactTooltip>
                  </span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(companyGrowthRef) => { this.companyGrowthRef = companyGrowthRef }}
                    value={(valuation.companyGrowthFactor) * 100}
                    decimalPrecision={0}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handleGrowthClick(this.industryGrowthRef) }}>Industry</span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(industryGrowthRef) => { this.industryGrowthRef = industryGrowthRef }}
                    value={(valuation.industryGrowthFactor - 1) * 100}
                    decimalPrecision={0}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handleGrowthClick(this.sp500GrowthRef) }}>SP500</span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(sp500GrowthRef) => { this.sp500GrowthRef = sp500GrowthRef }}
                    value={(valuation.sp500GrowthFactor - 1) * 100}
                    decimalPrecision={0}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
            </ul>

            <span className="fr fw7 pl1 b">
              <NumberFormat value={valuation.theoreticalGrowthFactor * 100} displayType={'text'} decimalPrecision={0} suffix="%" />
            </span>
            <input
              id='growthInput'
              className='w-100'
              value={this.state.growth}
              type='range'
              min='-0.5'
              max='1.5'
              step="0.01"
              onChange={this.handleGrowthChange.bind(this)}
              ref={(input) => { this.growthSlider = input; }} />
          </div>

          <hr />
          <h3>&nbsp; &nbsp; ADVANCED
          <i data-tip data-for='advanced' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='advanced' place='top' class='mw6'>
            <p className="f6">PM and PE sliders should be modified only if the user has unique insight into the future possibilities of the company.
           Typically, it is best to use the default values for the PM and PE sliders and focus on determining an appropriate value for the Sales Growth slider. </p>
          </ReactTooltip> </h3>
          {/*04/03/20 new code Profit Margin
        PM SLIDER INSERTED HERE*/}
          <div className="group pa3 ">
            <H4>
              Future Profit Margin (PM) Slider
            </H4>
               <span> 
            <a className="link blue" href={"https://youtu.be/RdlW0OcHmz4?list=PL2dQtklQds_vMRcyDmyLhMV7q5zEVEex4&t=46"} target="_blank"> How To </a>
        </span>
            <p className="f6 gray">Future earnings = Future PM x Future Sales, thus Future PM is a significant factor in valuation. Move the slider to a value of your choosing. Click on Default, Company, Industry, or SP500 to set to a predetermined value. </p>
            <p className="f6 gray">Click on <strong>Default</strong> to reset.</p>
            <ul className="list ma0 pa0">
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePMClick(this.futurePMRef) }}>Default
                  <i data-tip data-for='PMdefault' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='PMdefault' place='top' class='mw6'>
                    <p className="f6"> In the spirit of capitalism, a positive outlook results in the default Future PM being the larger of Industry PM, Sector PM, and average of recent Company PMs.</p>
                  </ReactTooltip>
                </span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(futurePMRef) => { this.futurePMRef = futurePMRef }}
                    value={futurePMDefault * 100}
                    decimalPrecision={1}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePMClick(this.companyPMRef) }}>Company
                <i data-tip data-for='companyPM' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='companyPM' place='top' class='mw6'>
                    <p className="f6">The company's historical average PM over last 3 years</p>
                  </ReactTooltip>
                  </span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(companyPMRef) => { this.companyPMRef = companyPMRef }}
                    value={valuation.companyPMFactor * 100}
                    decimalPrecision={1}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePMClick(this.industryPMRef) }}>Industry</span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(industryPMRef) => { this.industryPMRef = industryPMRef }}
                    value={valuation.industryPMFactor * 100}
                    decimalPrecision={1}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePMClick(this.sp500PMRef) }}>SP500</span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(sp500PMRef) => { this.sp500PMRef = sp500PMRef }}
                    value={valuation.sp500PMFactor}
                    decimalPrecision={1}
                    displayType={"text"}
                    suffix={"%"} />
                </span>
              </li>
            </ul>
            <span className="fr fw7 pl1 b">
              <NumberFormat value={valuation.futurePMFactor * 100} displayType={'text'} decimalPrecision={1} suffix="%" />
            </span>
            <input
              id='PMInput'
              className='w-100'
              value={this.state.PM}
              type='range'
              min='0.0'
              max='0.4'
              step='0.001'
              onChange={this.handlePMChange.bind(this)}
              ref={(input) => { this.PMSlider = input; }} />
    
          </div>
          <hr />
          {/*05/07/20 new code Price Earnings Ratio
        PE SLIDER INSERTED HERE*/}
          <div className="group pa3 ">
            <H4>
              Future Price/Earnings (PE) Slider
                <i data-tip data-for='PESlider' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='PESlider' place='top' class='mw6'>
                    <p className="f6">PE = (1-Reinvestment)/(CoE - (Project Return)(Reinvestment)). Future CoE is shown in the Company Information section. Mature companies tend towards 33% Reinvestment. Consider the Project Return (r) implied by the PE multiple. Compare r to ROE. An r > (COE +.03) is excessive. (r)(Reinvestment) > yield on 10 year T-bond excessive. </p>
                  </ReactTooltip>
            </H4>
               <span>
            <a className="link blue" href={"https://youtu.be/zlROi7_aLZo?list=PL2dQtklQds_vMRcyDmyLhMV7q5zEVEex4&t=816"} target="_blank"> How To,  </a>
            <a className="link blue" href={"https://youtu.be/YK7N_8FoQUw?list=PL2dQtklQds_trxvLKzCPoXSputbTSCR3X&t=2792"} target="_blank"> PE Check </a>
        </span> 
            <p className="f6 gray">Future price = Future PE x Future earnings, thus Future PE is a significant factor in valuation. Move the slider to a value of your choosing. Click on Default, Company, Industry, or SP500 to set to a predetermined value. </p>
            <p className="f6 gray">Click on <strong>Default</strong> to reset.</p>
            <ul className="list ma0 pa0">
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePEClick(this.futurePERef) }}>Default
                <i data-tip data-for='PEdefault' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='PEdefault' place='top' class='mw6'>
                    <p className="f6">The default Future PE assumes return on projects (r) equals the CoE, thus Future PE = (1+Future CoE)/Future CoE. As a sanity check, compare default future PE with future PE calculated using Current Cost of Equity (CoE).</p>
                  </ReactTooltip>
                </span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(futurePERef) => { this.futurePERef = futurePERef }}
                    value={futurePEDefault}
                    decimalPrecision={1}
                    displayType={"text"}/>
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePEClick(this.companyPERef) }}>Company
                <i data-tip data-for='companyPE' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='companyPE' place='top' class='mw6'>
                    <p className="f6">The company's historical average PE over last 3 years</p>
                  </ReactTooltip>
                  </span>
                  <span className="fr f6">
                  <NumberFormat
                    ref={(companyPERef) => { this.companyPERef = companyPERef }}
                    value={valuation.companyPEFactor}
                    decimalPrecision={1}
                    displayType={"text"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePEClick(this.industryPERef) }}>Industry
                <i data-tip data-for='PEindustry' className="material-icons light-silver f4 fr pointer">help_outline</i>
                  <ReactTooltip id='PEindustry' place='top' class='mw6'>
                    <p className="f6">The Industry Future PE is based on the industry unlevered Beta (Levered Beta = (Unlevered Beta)(1+(1-T)(Debt/Equity))) relevered to company Debt/Equity ratio. Future PE = (1+CoE)/CoE, assuming return on projects equals CoE. CoE = Rf + Beta*ERP, where Rf is Risk Free rate and ERP is the Equity Risk Premium.</p>
                  </ReactTooltip>
                  </span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(industryPERef) => { this.industryPERef = industryPERef }}
                    value={valuation.industryPEFactor}
                    decimalPrecision={1}
                    displayType={"text"} />
                </span>
              </li>
              <li className="cf bb b--black-10 pv2">
                <span className="fl f6 link blue pointer" onClick={() => { this.handlePEClick(this.sp500PERef) }}>SP500</span>
                <span className="fr f6">
                  <NumberFormat
                    ref={(sp500PERef) => { this.sp500PERef = sp500PERef }}
                    value={valuation.sp500PEFactor}
                    decimalPrecision={1}
                    displayType={"text"} />
                </span>
              </li>
            </ul>
            
            <span className="fr fw7 pl1 b">
              <NumberFormat value={valuation.futurePEFactor} displayType={'text'} decimalPrecision={1} />
            </span>
            <input
              id='PEInput'
              className='w-100'
              value={this.state.PE}
              type='range'
              min='0.0'
              max='30.0'
              step='0.1'
              onChange={this.handlePEChange.bind(this)}
              ref={(input) => { this.PESlider = input; }} />
    
          </div>
          <hr />
        </div>
      </Column33>
    )
  }
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar.js